"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.updateScheme = exports.setSelectedScheme = exports.setSchemes = exports.resetTheme = exports.setTheme = void 0;

var _redux = require("../../helpers/redux");

var setTheme = (0, _redux.createAction)("EDITOR/THEME/setTheme");
exports.setTheme = setTheme;
var resetTheme = (0, _redux.createAction)("EDITOR/THEME/resetTheme");
exports.resetTheme = resetTheme;
var setSchemes = (0, _redux.createAction)("EDITOR/THEME/setSchemes");
exports.setSchemes = setSchemes;
var setSelectedScheme = (0, _redux.createAction)("EDITOR/THEME/setSelectedScheme");
exports.setSelectedScheme = setSelectedScheme;
var updateScheme = (0, _redux.createAction)("EDITOR/THEME/updateScheme");
exports.updateScheme = updateScheme;
var _default = {
  setTheme: setTheme,
  resetTheme: resetTheme,
  setSchemes: setSchemes,
  setSelectedScheme: setSelectedScheme
};
exports["default"] = _default;